// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bcz_a bhs_ea bhs_ke bhs_ju bhs_sn bhs_wl"};